/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Request_FailedInputs */

const en_invoice_request_failed = /** @type {(inputs: Invoice_Request_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not send the request. Try again.`)
};

const pl_invoice_request_failed = /** @type {(inputs: Invoice_Request_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się wysłać prośby. Spróbuj ponownie.`)
};

/**
* | output |
* | --- |
* | "Could not send the request. Try again." |
*
* @param {Invoice_Request_FailedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const invoice_request_failed = /** @type {((inputs?: Invoice_Request_FailedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Request_FailedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_invoice_request_failed(inputs)
	return en_invoice_request_failed(inputs)
});